import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { TextField } from '@folio/stripes-components';
import { FormattedMessage, useIntl } from 'react-intl';

const propTypes = {
  fieldName: PropTypes.string,
};

function TextFieldType({ fieldName }) {
  const intl = useIntl();

  return (
    <Field
      name={`${fieldName}.defaultValue`}
      type="text"
      component={TextField}
      placeHolder={intl.formatMessage({
        id: 'ui-plugin-inventory-templates.templateField.defaultValue.textFieldtype.chooseMsg',
        defaultMessage: 'Add a default value',
      })}
      fullWidth
      label={
        <FormattedMessage
          id="ui-plugin-inventory-templates.templateField.defaultValue.label"
          defaultMessage="Default value"
        />
      }
    />
  );
}

TextFieldType.propTypes = propTypes;

export default TextFieldType;
